import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { FormLayout } from "../common/FormLayout";

export const DeleteAccountConfirmationPage = () => {
  const { t } = useTranslation();
  return (
    <FormLayout title={t("delete-account-title")}>
      <div className="text-center space-y-6">
        <div className="text-secondary-text">
          <FontAwesomeIcon icon="check-circle" size="3x" />
        </div>

        <div className="inline-block bg-secondary-text p-6 rounded-lg">
          <p className="text-tertiary font-oxaniumMedium">
            {t("delete-account-success")}
          </p>
        </div>

        <div className="mt-8 space-y-4">
          <a href="/login" className="block text-tertiary hover:underline">
            {t("delete-account-login-other")}
          </a>
          <a href="/register" className="block text-tertiary hover:underline">
            {t("delete-account-create-new")}
          </a>
        </div>
      </div>
    </FormLayout>
  );
};
